<template>
  <v-dialog v-model="dialog" max-width="960" persistent>
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('soldAssetResultDialog.label.title') }}</strong></h3>
      </v-card-title>
      <v-card-text>
        <v-table density="compact" class="mb-4">
          <tbody>
            <tr>
              <th>{{ $t('soldAssetResultDialog.label.fileName') }}</th>
              <td>{{ result.fileName }}</td>
              <th>{{ $t('soldAssetResultDialog.label.execDatetime') }}</th>
              <td>{{ execDatetime }}</td>
            </tr>
            <tr>
              <th>{{ $t('soldAssetResultDialog.label.user') }}</th>
              <td>{{ userLabel }}</td>
              <th>{{ $t('soldAssetResultDialog.label.status') }}</th>
              <td>{{ result.status }}</td>
            </tr>
          </tbody>
        </v-table>
        <v-row class="mb-2">
          <v-col v-for="count in counts" :key="count.key" cols="3">
            <v-card variant="outlined" class="pa-2 text-center">
              <div class="text-caption">{{ $t('soldAssetResultDialog.label.' + count.key) }}</div>
              <div class="text-h6" :class="count.cls" :data-count="count.key">{{ count.value }}</div>
            </v-card>
          </v-col>
        </v-row>
        <div class="mb-2">{{ $t('soldAssetResultDialog.label.detailList') }}</div>
        <div v-if="detailList.length == 0">{{ $t('soldAssetResultDialog.message.noDetail') }}</div>
        <v-table v-else density="compact" fixed-header height="320px" class="text-no-wrap">
          <thead>
            <tr>
              <th v-for="header in headers" :key="header">{{ $t('soldAssetResultDialog.label.table.' + header) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in detailList" :key="data.lineNo">
              <td v-for="header in headers" :key="header">{{ data[header] }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="bg-indigo-darken-1" dark :disabled="detailList.length == 0" @click="downloadErrorCsv">
          {{ $t('soldAssetResultDialog.action.downloadErrorCsv') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="indigo darken-1" @click="close">{{ $t('soldAssetResultDialog.action.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// 売却済み資産ファイルの取込結果ダイアログ
// dialogData.result 取込結果（件数・スキップ／エラー明細）
import utils from "@/utils";

export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      headers: ["lineNo", "janCode", "resultType", "originSitezoneCode", "message"],
    };
  },
  computed: {
    result() {
      return this.dialogData.result ?? {};
    },
    detailList() {
      return this.result.detailList ?? [];
    },
    execDatetime() {
      return utils.putSplitWordToCalendarWithTime(this.result.execDatetime);
    },
    userLabel() {
      return this.result.userName ? `${this.result.userId} ${this.result.userName}` : this.result.userId;
    },
    counts() {
      return [
        { key: "totalCount", value: this.result.totalCount, cls: "" },
        { key: "movedCount", value: this.result.movedCount, cls: "text-success" },
        { key: "skipCount", value: this.result.skipCount, cls: "text-warning" },
        { key: "errorCount", value: this.result.errorCount, cls: "text-error" },
      ];
    },
  },
  methods: {
    close() {
      this.handleClose();
    },
    // スキップ・エラー明細をCSV出力する（値はダブルクォートで囲む）
    downloadErrorCsv() {
      const quote = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
      const lines = [];
      lines.push(this.headers.map((h) => quote(this.$t("soldAssetResultDialog.label.table." + h))).join(","));
      this.detailList.forEach((row) => {
        lines.push(this.headers.map((h) => quote(row[h])).join(","));
      });
      const prefix = this.$t("soldAssetResultDialog.fileNamePrefix.errorCsv");
      utils.csvDownload(lines.join("\r\n") + "\r\n", `${prefix}${utils.csvTimeStamp(new Date())}`);
    },
  },
};
</script>
